import React, { useState, useEffect, useCallback } from "react";
import allTeams from "../data/teams"; // Adjust the import path as necessary
import { Link } from "react-router-dom";
import apiUrl from "../config";
import { useParams } from "react-router-dom";
import ChartGameResume from "../component/game/ChartGameResume";
import StarPlayer from "../component/game/StarPlayer";
import Score from "../component/game/Score";
import PlayByPlay from "../component/game/PlayByPlay";
import PointPerPlayer from "../component/game/PointPerPlayer";
import AdBanner from "../component/ads/AdBanner";
interface ChartGameResumeProps {
  game: any[]; // Replace `any` with the actual type for `game`
  homeTeam: any[]; // Replace `any` with the actual type for `homeTeam`
  awayTeam: any[]; // Replace `any` with the actual type for `awayTeam`
}

interface Team {
  id: number;
  franchiseId: number;
  fullName: string;
  leagueId: number;
  rawTricode: string;
  triCode: string;
  colors: string[];
  conference: string;
  division: string;
}

const Game: React.FC = () => {
  const seasonYears = "20252026";
  const [game, setGame] = useState<any>([]);
  const [homeTeam, setHomeTeam] = useState<any>([]);
  const [awayTeam, setAwayTeam] = useState<any>([]);
  const [homeTeamGoalByPeriod, setHomeTeamGoalByPeriod] = useState([]);
  const [awayTeamGoalByPeriod, setAwayTeamGoalByPeriod] = useState([]);
  const [homeTeamShotByPeriod, setHomeTeamShotByPeriod] = useState([]);
  const [awayTeamShotByPeriod, setAwayTeamShotByPeriod] = useState([]);
  const [homeTeamPenaltyByPeriod, setHomeTeamPenaltyByPeriod] = useState([]);
  const [awayTeamPenaltyByPeriod, setAwayTeamPenaltyByPeriod] = useState([]);
  const [homeTeamHitByPeriod, setHomeTeamHitByPeriod] = useState([]);
  const [awayTeamHitByPeriod, setAwayTeamHitByPeriod] = useState([]);
  const [homeTeamPlayers, setHomeTeamPlayers] = useState([]);
  const [awayTeamPlayers, setAwayTeamPlayers] = useState([]);

  const [colorsTeam, setColorsTeam] = useState([]);
  const [loading, setLoading] = useState(true); // State to hold the team's colors
  const [colorsTeamOpponent, setColorsTeamOpponent] = useState([]);
  const [dateGame, setDateGame] = useState("");
  const [plays, setPlay] = useState([]);
  const { gameId } = useParams();
  const [homeTeamColor, setHomeTeamColor] = useState<string[]>([]);
  const [awayTeamColor, setAwayTeamColor] = useState<string[]>([]);
  const [apiError, setApiError] = useState(false);
  const [retryCountdown, setRetryCountdown] = useState(0);

  const fetchTeams = async (teamCode) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/teams/roster/${teamCode}/20252026`,
      ); // Adjust the endpoint as necessary
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      } // Replace with the actual API URL
      const rosters = await response.json();
      return rosters;
    } catch (error) {
      console.error("Error fetching teams:", error);
    }
  };

  const fetchGame = async (gameId) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/game/play-by-play/${gameId}/`,
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log("game data", data);
      setGame(data);
      //   const homeTeam = allTeams.find(team => team.rawTricode === data.awayTeam.abbrev);
      //   const awayTeam = allTeams.find(team => team.rawTricode === data.homeTeam.abbrev);
      setPlay(data.plays);
      setHomeTeam(data.homeTeam);
      setAwayTeam(data.awayTeam);
      setDateGame(data.gameDate);
      setLoading(false);
      setApiError(false);
      setRetryCountdown(0);
    } catch (error) {
      console.error("Error fetching game:", error);
      setLoading(false);
      setApiError(true);
      setRetryCountdown(10);
    }
  };

  // const getActionInPlays = (plays, action) => {
  //     // Filter plays for goals by the specified team
  //     const actionType = plays.filter(play => play.typeDescKey === action);
  //     console.log("actionType", actionType);
  //     return actionType;
  // }

  // console.log("goal array", getActionInPlays(plays, "goal"));

  // console.log("faceoff array", getActionInPlays(plays, "faceoff"));

  // const getAllFaceOffs = getActionInPlays(plays, "faceoff")

  // const winnerFaceOff = getAllFaceOffs.map(faceoff => {
  //     const winningPlayersFaceoff = [];
  //     const playerWinner = homeTeamPlayers.find(player => player.id === faceoff.details.winningPlayerId) ||
  //                          awayTeamPlayers.find(player => player.id === faceoff.details.winningPlayerId);
  //     if (playerWinner) {
  //         winningPlayersFaceoff.push(playerWinner);
  //     }
  //     return winningPlayersFaceoff;
  // });

  // const getGoalsByTeamAndPeriod = (teamId, plays) => {
  //     // Filter plays for goals by the specified team
  //     const goals = plays.filter(play =>
  //         play.typeDescKey === 'goal' && play.details.eventOwnerTeamId === teamId
  //     );

  //     // Group goals by period
  //     const goalsByPeriod = goals.reduce((acc, plays) => {
  //         const period = plays.periodDescriptor.number;
  //         if (!acc[period]) {
  //             acc[period] = [];
  //         }
  //         acc[period].push(plays);
  //         return acc;
  //     }, {});

  //     return goalsByPeriod;
  // };

  // const getShotsByTeamAndPeriod = (teamId, plays) => {
  //     // Filter plays for goals by the specified team
  //     const shots = plays.filter(play =>
  //         play.typeDescKey === 'shot-on-goal' && play.details.eventOwnerTeamId === teamId
  //     );

  //     // Group goals by period
  //     const shotsByPeriod = shots.reduce((acc, plays) => {
  //         const period = plays.periodDescriptor.number;
  //         if (!acc[period]) {
  //             acc[period] = [];
  //         }
  //         acc[period].push(plays);
  //         return acc;
  //     }, {});

  //     return shotsByPeriod;
  // };

  const getActionByTeamAndPeriod = (
    teamId: number,
    plays: any[],
    action: string,
  ) => {
    // Filter plays for goals by the specified team
    const events = plays.filter((play) => {
      if (action === "shot-on-goal") {
        return (
          (play.typeDescKey === "shot-on-goal" ||
            play.typeDescKey === "goal") &&
          play.details.eventOwnerTeamId === teamId
        );
      } else {
        return (
          play.typeDescKey === action &&
          play.details.eventOwnerTeamId === teamId
        );
      }
    });

    // Group goals by period
    const eventsByPeriod = events.reduce((acc, plays) => {
      const period = plays.periodDescriptor.number;
      if (!acc[period]) {
        acc[period] = [];
      }
      acc[period].push(plays);
      return acc;
    }, {});

    return eventsByPeriod;
  };

  // Analyze powerplay situations based on actual player counts on ice
  const analyzePowerplayStats = (plays, homeTeam, awayTeam) => {
    const homeTeamId = homeTeam.id;
    const awayTeamId = awayTeam.id;
    
    let homeTeamPPGoals = 0;
    let awayTeamPPGoals = 0;
    let homeTeamPPOpportunities = 0;
    let awayTeamPPOpportunities = 0;
    
    // Track when PP situations start (based on penalties, not faceoffs)
    const ppTracking = {
      currentHomePP: false,
      currentAwayPP: false,
    };

    plays?.forEach((play, index) => {
      if (!play.situationCode || play.situationCode.length < 4) return;

      // Parse situationCode: position[1]=away players, position[2]=home players
      const awayPlayersOnIce = parseInt(play.situationCode.toString()[1], 10);
      const homePlayersOnIce = parseInt(play.situationCode.toString()[2], 10);

      // Validate player counts
      if (isNaN(homePlayersOnIce) || isNaN(awayPlayersOnIce)) return;

      // CRITICAL: Only count as PP if one team has FEWER players (not equal strength)
      // Equal strength situations (5v5, 4v4, 3v3) are NOT powerplays
      
      // Check if home team has powerplay (away team has fewer players)
      const homeHasPP = homePlayersOnIce > awayPlayersOnIce && 
                        awayPlayersOnIce < 5 && 
                        homePlayersOnIce <= 5;
      
      // Check if away team has powerplay (home team has fewer players)
      const awayHasPP = awayPlayersOnIce > homePlayersOnIce && 
                        homePlayersOnIce < 5 && 
                        awayPlayersOnIce <= 5;

      // Track when a new PP opportunity begins
      // A penalty creates a new PP opportunity when it transitions from equal strength to PP
      if (play.typeDescKey === "penalty") {
        // Check next few plays to see if this penalty leads to a PP situation
        const nextPlays = plays.slice(index + 1, index + 5);
        const leadsToHomePP = nextPlays.some(nextPlay => {
          if (!nextPlay.situationCode || nextPlay.situationCode.length < 4) return false;
          const nextAway = parseInt(nextPlay.situationCode.toString()[1], 10);
          const nextHome = parseInt(nextPlay.situationCode.toString()[2], 10);
          return nextHome > nextAway && nextAway < 5 && nextHome <= 5;
        });
        const leadsToAwayPP = nextPlays.some(nextPlay => {
          if (!nextPlay.situationCode || nextPlay.situationCode.length < 4) return false;
          const nextAway = parseInt(nextPlay.situationCode.toString()[1], 10);
          const nextHome = parseInt(nextPlay.situationCode.toString()[2], 10);
          return nextAway > nextHome && nextHome < 5 && nextAway <= 5;
        });

        // Count this penalty as creating a PP opportunity
        if (leadsToHomePP && play.details.eventOwnerTeamId === awayTeamId) {
          homeTeamPPOpportunities += 1;
        } else if (leadsToAwayPP && play.details.eventOwnerTeamId === homeTeamId) {
          awayTeamPPOpportunities += 1;
        }
      }

      // Count powerplay goals
      if (play.typeDescKey === "goal") {
        if (homeHasPP && play.details.eventOwnerTeamId === homeTeamId) {
          homeTeamPPGoals += 1;
        }
        if (awayHasPP && play.details.eventOwnerTeamId === awayTeamId) {
          awayTeamPPGoals += 1;
        }
      }
    });

    // Calculate success percentages
    const homeTeamPPPercentage = homeTeamPPOpportunities > 0 
      ? ((homeTeamPPGoals / homeTeamPPOpportunities) * 100).toFixed(1)
      : 0;
    
    const awayTeamPPPercentage = awayTeamPPOpportunities > 0
      ? ((awayTeamPPGoals / awayTeamPPOpportunities) * 100).toFixed(1)
      : 0;

    console.log("Powerplay Analysis:", {
      home: {
        team: homeTeam.abbrev,
        goals: homeTeamPPGoals,
        opportunities: homeTeamPPOpportunities,
        percentage: homeTeamPPPercentage + "%"
      },
      away: {
        team: awayTeam.abbrev,
        goals: awayTeamPPGoals,
        opportunities: awayTeamPPOpportunities,
        percentage: awayTeamPPPercentage + "%"
      }
    });

    return {
      homeTeamPPGoals,
      awayTeamPPGoals,
      homeTeamPPOpportunities,
      awayTeamPPOpportunities,
      homeTeamPPPercentage,
      awayTeamPPPercentage,
    };
  };

  const actionsCountperTeam = (plays, homeTeam, awayTeam, action) => {
    const homeTeamId = homeTeam.id;
    const awayTeamId = awayTeam.id;
    let homeTeamCount = 0;
    let awayTeamCount = 0;

    if (action === "powerplaygoal") {
      // Use the new powerplay analysis function
      const ppStats = analyzePowerplayStats(plays, homeTeam, awayTeam);
      return {
        homeTeamCountPower: ppStats.homeTeamPPGoals,      // Home team PP goals
        awayTeamCountPower: ppStats.awayTeamPPGoals,      // Away team PP goals
        homeTeamCountPenalty: ppStats.homeTeamPPOpportunities,  // Home team PP opportunities
        awayTeamCountPenalty: ppStats.awayTeamPPOpportunities,  // Away team PP opportunities
        action,
      };
    } else {
      const actionList = plays
        ?.filter((play) => play.typeDescKey === action)
        .map((play, index) => {
          homeTeamId === play.details.eventOwnerTeamId
            ? (homeTeamCount += 1)
            : (awayTeamCount += 1);
        });
      return { homeTeamCount, awayTeamCount, action };
    }
  };

  const resultAction = (plays, homeTeam, awayTeam, action) => {
    let percentage1 = 0;
    let percentage2 = 0;
    let percentage = 50;
    let result = actionsCountperTeam(plays, homeTeam, awayTeam, action);
    
    if (action == "powerplaygoal") {
      // Don't display if there are no PP opportunities (offsetting penalties, fighting, etc.)
      const totalPPOpportunities = (result?.homeTeamCountPenalty || 0) + (result?.awayTeamCountPenalty || 0);
      if (totalPPOpportunities === 0) {
        return null; // Don't render anything if no actual powerplays occurred
      }
      
      // Calculate each team's PP success percentage (goals/opportunities)
      percentage1 =
        result?.homeTeamCountPenalty > 0
          ? Math.ceil(
              (result?.homeTeamCountPower / result?.homeTeamCountPenalty) * 100,
            )
          : 0;
      percentage2 =
        result?.awayTeamCountPenalty > 0
          ? Math.ceil(
              (result?.awayTeamCountPower / result?.awayTeamCountPenalty) * 100,
            )
          : 0;
      // For gradient, use relative comparison of total PP goals
      const totalPPGoals = (result?.homeTeamCountPower || 0) + (result?.awayTeamCountPower || 0);
      percentage = totalPPGoals > 0
        ? Math.ceil(
            (result?.homeTeamCountPower / totalPPGoals) * 100,
          )
        : 50;
    } else {
      percentage =
        Math.ceil(
          (result?.homeTeamCount /
            (result?.awayTeamCount + result?.homeTeamCount)) *
            100,
        ) || 0;
      percentage1 = percentage;
      percentage2 = 100 - percentage;
    }
    let actionLabel = "";
    switch (action) {
      case "goal":
        actionLabel = "GOALS";
        break;
      case "shot-on-goal":
        actionLabel = "SHOTS ON GOAL";
        break;
      case "powerplaygoal":
        actionLabel = "POWERPLAY SUCCESS %";
        break;
      case "faceoff":
        actionLabel = "FACEOFFS WON";
        break;
      case "takeaway":
        actionLabel = "TAKEAWAYS";
        break;
      case "blocked-shot":
        actionLabel = "BLOCKED SHOTS";
        break;
      case "missed-shot":
        actionLabel = "MISSED SHOTS";
        break;
      case "hit":
        actionLabel = "HITS";
        break;
      default:
        actionLabel = action.toUpperCase();
    }
    //  if(percentage !== 0 && percentage !== 100) {
    return (
      <div>
        <div className="resultAction" style={{ textTransform: "uppercase" }}>
          <div>{actionLabel}</div>
        </div>
        <div
          className="resultAction"
          style={{
            border: "2px solid #fff",
            borderRadius: "5px",
            background: `linear-gradient(45deg, ${homeTeamColor[0]} ${percentage}%, rgba(255, 255, 255, 1) ${percentage}%, rgba(255, 255, 255, 1) ${percentage + 5}%, ${awayTeamColor[0]} ${percentage + 5}%)`,
          }}
        >
          {/* Left side: Home team stats */}
          <div>
            {percentage1}% {result?.homeTeamCountPower}
            {result?.homeTeamCountPenalty ? "/" : ""}
            {result?.homeTeamCountPenalty}
          </div>
          {/* Right side: Away team stats */}
          <div>
            {percentage2}% {result?.awayTeamCountPower}
            {result?.awayTeamCountPower != null ? "/" : ""}
            {result?.awayTeamCountPenalty}
          </div>
        </div>
      </div>
    );
    //}
  };

  const getTeamColor = (teamId: number, allTeams: Team[]) => {
    const team = allTeams.find((team) => team.id === teamId);
    return team ? team.colors : null; // Return the color if the team is found, otherwise return null
  };

  useEffect(() => {
    if (plays.length > 0) {
      setHomeTeamGoalByPeriod(
        getActionByTeamAndPeriod(game.homeTeam.id, plays, "goal"),
      );
      setAwayTeamGoalByPeriod(
        getActionByTeamAndPeriod(game.awayTeam.id, plays, "goal"),
      );

      setHomeTeamShotByPeriod(
        getActionByTeamAndPeriod(game.homeTeam.id, plays, "shot-on-goal"),
      );
      setAwayTeamShotByPeriod(
        getActionByTeamAndPeriod(game.awayTeam.id, plays, "shot-on-goal"),
      );

      setHomeTeamPenaltyByPeriod(
        getActionByTeamAndPeriod(game.homeTeam.id, plays, "penalty"),
      );
      setAwayTeamPenaltyByPeriod(
        getActionByTeamAndPeriod(game.awayTeam.id, plays, "penalty"),
      );

      setHomeTeamHitByPeriod(
        getActionByTeamAndPeriod(game.homeTeam.id, plays, "hit"),
      );
      setAwayTeamHitByPeriod(
        getActionByTeamAndPeriod(game.awayTeam.id, plays, "hit"),
      );
    }

    console.log(
      actionsCountperTeam(game.plays, homeTeam, awayTeam, "takeaway"),
    );
    console.log(actionsCountperTeam(game.plays, homeTeam, awayTeam, "faceoff"));
    console.log(
      actionsCountperTeam(game.plays, homeTeam, awayTeam, "blocked-shot"),
    );
    console.log(
      actionsCountperTeam(game.plays, homeTeam, awayTeam, "missed-shot"),
    );
    console.log(actionsCountperTeam(game.plays, homeTeam, awayTeam, "hit"));
    console.log(
      actionsCountperTeam(game.plays, homeTeam, awayTeam, "shot-on-goal"),
    );
    console.log(actionsCountperTeam(game.plays, homeTeam, awayTeam, "goal"));
    console.log(
      actionsCountperTeam(game.plays, homeTeam, awayTeam, "powerplaygoal"),
    );

    const safeHomeTeamColor: string[] = getTeamColor(homeTeam.id, allTeams) || [
      "#FFFFFF",
    ]; // Default to black
    setHomeTeamColor(safeHomeTeamColor);
    const safeAwayTeamColor: string[] = getTeamColor(awayTeam.id, allTeams) || [
      "#FFFFF",
    ]; // Default to black
    setAwayTeamColor(safeAwayTeamColor);
  }, [plays, game]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchGame(gameId); // Assuming fetchGame is an async function
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [gameId]);

  // Retry countdown timer
  useEffect(() => {
    if (retryCountdown > 0) {
      const timer = setTimeout(() => {
        setRetryCountdown(retryCountdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (retryCountdown === 0 && apiError) {
      // Retry fetching after countdown reaches 0
      fetchGame(gameId);
    }
  }, [retryCountdown, apiError, gameId]);

  useEffect(() => {
    if (game.length > 0) {
      setLoading(true);
      // Process games data if needed
      setLoading(false);
    }
  }, [game]);

  useEffect(() => {
    const isActive = game.gameState === "LIVE" || game.gameState === "CRIT";
    let intervalId: NodeJS.Timeout | undefined;

    if (isActive) {
      intervalId = setInterval(async () => {
        try {
          await fetchGame(gameId); // Assuming fetchGame is an async function
        } catch (error) {
          console.error("Error fetching data:", error);
        } // Replace with your actual refresh function
      }, 10000); // 10 seconds
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [game.gameState, gameId, fetchGame]);

  if (apiError) {
    return (
      <div className="wrapper">
        <div className="main">
          <div style={{ textAlign: "center", padding: "40px" }}>
            <h2 style={{ color: "#e74c3c" }}>⚠️ API Connection Error</h2>
            <p>Unable to load game data. The API is not responding.</p>
            {retryCountdown > 0 ? (
              <p style={{ fontSize: "18px", marginTop: "20px" }}>
                Retrying in <strong>{retryCountdown}</strong> seconds...
              </p>
            ) : (
              <p style={{ fontSize: "18px", marginTop: "20px" }}>
                Retrying now...
              </p>
            )}
            <button
              onClick={() => fetchGame(gameId)}
              style={{
                marginTop: "20px",
                padding: "10px 20px",
                fontSize: "16px",
                cursor: "pointer",
                backgroundColor: "#3498db",
                color: "white",
                border: "none",
                borderRadius: "5px",
              }}
            >
              Retry Now
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (loading || !homeTeam?.abbrev || !awayTeam?.abbrev) {
    return (
      <div className="wrapper">
        <div className="main">
          <div style={{ textAlign: "center", padding: "40px" }}>
            <h2>Loading game data...</h2>
            <div style={{ marginTop: "20px", fontSize: "18px" }}>⏳</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="wrapper">
      <div className="main">
        <div className="statsboxGame">
          <div>
            <Score game={game} homeTeam={homeTeam} awayTeam={awayTeam} />
          </div>

          <div className="gamechartStats">
            <StarPlayer game={game} homeTeam={homeTeam} awayTeam={awayTeam} />
          </div>

          <div className="gamechartStats">
            <div className="col75">
              <ChartGameResume
                game={game}
                homeTeam={homeTeam}
                awayTeam={awayTeam}
              />
              <PlayByPlay game={game} awayTeam={awayTeam} homeTeam={homeTeam} />
            </div>
            <div className="col25">
              <div className="teamContent">
                <div className="title">SCOREBOARD</div>
                <div>
                  <div className="scoreBoxRow">
                    <div>Score</div>
                    <div>1st</div>
                    <div>2nd</div>
                    <div>3rd</div>
                    <div>OT</div>

                    <div>Total</div>
                  </div>
                  <div className="scoreBoxRow">
                    <div>
                      <Link to={`/team/${homeTeam.abbrev}`}>
                        <img
                          src={homeTeam.darkLogo}
                          style={{ width: "30px", height: "30px" }}
                        />
                      </Link>
                    </div>
                    <div>{homeTeamGoalByPeriod?.[1]?.length || 0}</div>
                    <div>{homeTeamGoalByPeriod?.[2]?.length || 0}</div>
                    <div>{homeTeamGoalByPeriod?.[3]?.length || 0}</div>
                    <div>{homeTeamGoalByPeriod?.[4]?.length || 0}</div>
                    <div>
                      {(homeTeamGoalByPeriod?.[1]?.length || 0) +
                        (homeTeamGoalByPeriod?.[2]?.length || 0) +
                        (homeTeamGoalByPeriod?.[3]?.length || 0) +
                        (homeTeamGoalByPeriod?.[4]?.length || 0)}
                    </div>
                  </div>

                  <div className="scoreBoxRow">
                    <div>
                      <Link to={`/team/${awayTeam.abbrev}`}>
                        <img
                          src={awayTeam.darkLogo}
                          style={{ width: "30px", height: "30px" }}
                        />
                      </Link>
                    </div>
                    <div>{awayTeamGoalByPeriod?.[1]?.length || 0}</div>
                    <div>{awayTeamGoalByPeriod?.[2]?.length || 0}</div>
                    <div>{awayTeamGoalByPeriod?.[3]?.length || 0}</div>
                    <div>{awayTeamGoalByPeriod?.[4]?.length || 0}</div>
                    <div>
                      {(awayTeamGoalByPeriod?.[1]?.length || 0) +
                        (awayTeamGoalByPeriod?.[2]?.length || 0) +
                        (awayTeamGoalByPeriod?.[3]?.length || 0) +
                        (awayTeamGoalByPeriod?.[4]?.length || 0)}
                    </div>
                  </div>
                </div>

                <div>
                  <div>
                    <div className="scoreBoxRow">
                      <div>Shots</div>
                      <div>1st</div>
                      <div>2nd</div>
                      <div>3rd</div>
                      <div>OT</div>

                      <div>total</div>
                    </div>
                    <div className="scoreBoxRow">
                      <div>
                        <Link to={`/team/${homeTeam.abbrev}`}>
                          <img
                            src={homeTeam.darkLogo}
                            style={{ width: "30px", height: "30px" }}
                          />
                        </Link>
                      </div>
                      <div>{homeTeamShotByPeriod?.[1]?.length || 0}</div>
                      <div>{homeTeamShotByPeriod?.[2]?.length || 0}</div>
                      <div>{homeTeamShotByPeriod?.[3]?.length || 0}</div>
                      <div>{homeTeamShotByPeriod?.[4]?.length || 0}</div>
                      <div>
                        {(homeTeamShotByPeriod?.[1]?.length || 0) +
                          (homeTeamShotByPeriod?.[2]?.length || 0) +
                          (homeTeamShotByPeriod?.[3]?.length || 0) +
                          (homeTeamShotByPeriod?.[4]?.length || 0)}
                      </div>
                    </div>

                    <div className="scoreBoxRow">
                      <div>
                        <Link to={`/team/${awayTeam.abbrev}`}>
                          <img
                            src={awayTeam.darkLogo}
                            style={{ width: "30px", height: "30px" }}
                          />
                        </Link>
                      </div>
                      <div>{awayTeamShotByPeriod?.[1]?.length || 0}</div>
                      <div>{awayTeamShotByPeriod?.[2]?.length || 0}</div>
                      <div>{awayTeamShotByPeriod?.[3]?.length || 0}</div>
                      <div>{awayTeamShotByPeriod?.[4]?.length || 0}</div>
                      <div>
                        {(awayTeamShotByPeriod?.[1]?.length || 0) +
                          (awayTeamShotByPeriod?.[2]?.length || 0) +
                          (awayTeamShotByPeriod?.[3]?.length || 0) +
                          (awayTeamShotByPeriod?.[4]?.length || 0)}
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div>
                    <div className="scoreBoxRow">
                      <div>Penalties</div>
                      <div>1st</div>
                      <div>2nd</div>
                      <div>3rd</div>
                      <div>OT</div>
                      <div>Total</div>
                    </div>
                    <div className="scoreBoxRow">
                      <div>
                        <Link to={`/team/${homeTeam.abbrev}`}>
                          <img
                            src={homeTeam.darkLogo}
                            style={{ width: "30px", height: "30px" }}
                          />
                        </Link>
                      </div>
                      <div>{homeTeamPenaltyByPeriod?.[1]?.length || 0}</div>
                      <div>{homeTeamPenaltyByPeriod?.[2]?.length || 0}</div>
                      <div>{homeTeamPenaltyByPeriod?.[3]?.length || 0}</div>
                      <div>{homeTeamPenaltyByPeriod?.[4]?.length || 0}</div>
                      <div>
                        {(homeTeamPenaltyByPeriod?.[1]?.length || 0) +
                          (homeTeamPenaltyByPeriod?.[2]?.length || 0) +
                          (homeTeamPenaltyByPeriod?.[3]?.length || 0) +
                          (homeTeamPenaltyByPeriod?.[4]?.length || 0)}
                      </div>
                    </div>

                    <div className="scoreBoxRow">
                      <div>
                        <Link to={`/team/${awayTeam.abbrev}`}>
                          <img
                            src={awayTeam.darkLogo}
                            style={{ width: "30px", height: "30px" }}
                          />
                        </Link>
                      </div>
                      <div>{awayTeamPenaltyByPeriod?.[1]?.length || 0}</div>
                      <div>{awayTeamPenaltyByPeriod?.[2]?.length || 0}</div>
                      <div>{awayTeamPenaltyByPeriod?.[3]?.length || 0}</div>
                      <div>{awayTeamPenaltyByPeriod?.[4]?.length || 0}</div>
                      <div>
                        {(awayTeamPenaltyByPeriod?.[1]?.length || 0) +
                          (awayTeamPenaltyByPeriod?.[2]?.length || 0) +
                          (awayTeamPenaltyByPeriod?.[3]?.length || 0) +
                          (awayTeamPenaltyByPeriod?.[4]?.length || 0)}
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div>
                    <div className="scoreBoxRow">
                      <div>Hit</div>
                      <div>1st</div>
                      <div>2nd</div>
                      <div>3rd</div>
                      <div>OT</div>
                      <div>Total</div>
                    </div>
                    <div className="scoreBoxRow">
                      <div>
                        <Link to={`/team/${homeTeam.abbrev}`}>
                          <img
                            src={homeTeam.darkLogo}
                            style={{ width: "30px", height: "30px" }}
                          />
                        </Link>
                      </div>
                      <div>{homeTeamHitByPeriod?.[1]?.length || 0}</div>
                      <div>{homeTeamHitByPeriod?.[2]?.length || 0}</div>
                      <div>{homeTeamHitByPeriod?.[3]?.length || 0}</div>
                      <div>{homeTeamHitByPeriod?.[4]?.length || 0}</div>
                      <div>
                        {(homeTeamHitByPeriod?.[1]?.length || 0) +
                          (homeTeamHitByPeriod?.[2]?.length || 0) +
                          (homeTeamHitByPeriod?.[3]?.length || 0) +
                          (homeTeamHitByPeriod?.[4]?.length || 0)}
                      </div>
                    </div>

                    <div className="scoreBoxRow">
                      <div>
                        <Link to={`/team/${awayTeam.abbrev}`}></Link>{" "}
                        <img
                          src={awayTeam.darkLogo}
                          style={{ width: "30px", height: "30px" }}
                        />
                      </div>
                      <div>{awayTeamHitByPeriod?.[1]?.length || 0}</div>
                      <div>{awayTeamHitByPeriod?.[2]?.length || 0}</div>
                      <div>{awayTeamHitByPeriod?.[3]?.length || 0}</div>
                      <div>{awayTeamHitByPeriod?.[4]?.length || 0}</div>
                      <div>
                        {(awayTeamHitByPeriod?.[1]?.length || 0) +
                          (awayTeamHitByPeriod?.[2]?.length || 0) +
                          (awayTeamHitByPeriod?.[3]?.length || 0) +
                          (awayTeamHitByPeriod?.[4]?.length || 0)}
                      </div>
                    </div>
                  </div>
                </div>

                {(game.gameState === "OFF" || game.gameState === "FINAL") && (
                  <div>
                    <div className="width100">
                      {/* Team logos: Home (left) | Away (right) */}
                      <div className="resultAction">
                        <div className="logo">
                          <Link to={`/team/${homeTeam.abbrev}`}>
                            <img
                              src={homeTeam.darkLogo}
                              style={{ width: "75px", height: "75px" }}
                            />
                          </Link>
                        </div>
                        <div className="logo">
                          <Link to={`/team/${awayTeam.abbrev}`}>
                            <img
                              src={awayTeam.darkLogo}
                              style={{ width: "75px", height: "75px" }}
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                    {resultAction(
                      game.plays,
                      homeTeam,
                      awayTeam,
                      "powerplaygoal",
                    )}
                    {resultAction(game.plays, homeTeam, awayTeam, "goal")}
                    {resultAction(game.plays, homeTeam, awayTeam, "faceoff")}
                    {resultAction(game.plays, homeTeam, awayTeam, "takeaway")}
                    {resultAction(
                      game.plays,
                      homeTeam,
                      awayTeam,
                      "blocked-shot",
                    )}
                    {resultAction(
                      game.plays,
                      homeTeam,
                      awayTeam,
                      "missed-shot",
                    )}
                    {resultAction(
                      game.plays,
                      homeTeam,
                      awayTeam,
                      "shot-on-goal",
                    )}
                    {resultAction(game.plays, homeTeam, awayTeam, "hit")}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Game;
